import { types } from "../actions";

export default (state = [], { type, payload }) => {
  switch (type) {
    case types.SET_CATEGORY_TREE:
      return payload;
    case types.RESET:
      return [];
    default:
      return state;
  }
};
